module.exports = __webpack_public_path__ + "img/spacial-student2.915f1522.png";